<template>
  <LeftNav :no-accordion="brand === 'bcom'" :heading="!customLeftNavHeader && brand === 'mcom' ? 'My Account' : ''">
    <template v-if="customLeftNavHeader" #custom-header>
      <li class="account-label" :class="brand === 'mcom' ? 'grid-x align-justify' : ''">
        <a v-if="brand === 'mcom'" class="large" href="/myaccount/home">My Account</a>
        <div class="grid-x align-right inbox-container">
          <div class="tooltip-wrapper">
            <Inbox />
            <div class="css-tooltip caret-top" :class="showTooltip ? 'open' : ''">Inbox</div>
          </div>
        </div>
      </li>
    </template>
  </LeftNav>
</template>

<script setup>
import { ref } from 'vue';
import LeftNav from '@nuxt-common/left-nav/app/components/LeftNav.vue';
import { brand } from 'config';
import Inbox from '@/components/inbox/Inbox';

const route = useRoute();
const { customLeftNavHeader } = route.meta;
const showTooltip = ref(false);
</script>

<style lang="scss" scoped brand="bcom">
.inbox-container {
  position: relative;
  margin-bottom: rem-calc(-50);
}
:deep(.left-nav > .account-label + .left-nav-link-block) {
  border-bottom: none;
}
</style>
<style lang="scss" scoped>
@import '@core/csg/src/scss/components/tooltip';
@include csg-tooltip;
.css-tooltip.caret-top {
  left: 50%;
  margin-top: 4px;
  transform: translateX(-50%);
}
.tooltip-wrapper {
  cursor: pointer;
}
.css-tooltip {
  display: none;
}
.tooltip-wrapper:hover .css-tooltip,
.tooltip-wrapper:focus-visible .css-tooltip {
  display: block;
}
</style>
